/**
 * Validates an email
 * @param {string} email
 * @returns Boolean whether or not the provided email is valid
 */
export function validateEmail(email) {
  if (typeof email !== "string") return false;
  const emailPattern = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
  return emailPattern.test(email.toLowerCase());
}

/**
 * Validates a full name
 * @param {string} name
 * @returns Boolean whether or not the provided full name is valid
 */
export function validatePersonName(name){
  if (typeof name !== "string") return false;
  const namePattern = new RegExp("\\b([a-z][-,a-z. ']+[ ]*)+", "gm");
  let regexResult = namePattern.test(name.toLowerCase())
  return regexResult
}

/**
 * Validates a username
 * 
 * https://auth0.com/docs/authenticate/database-connections/require-username
 * 
 * @param {string} username 
 * @returns Boolean whether or not the provided username is valid
 */
export function validateUsername(username) {
  if (typeof username !== "string") return false;
  const usernamePattern = /^[a-z0-9@^$.!`\-#+'~_]+$/;
  const isLengthCorrect = username.length > 0 && username.length <= 15;
  return !validateEmail(username) && usernamePattern.test(username) && isLengthCorrect;
}


export function channelPageInputValidator(key, value){
  if (value === undefined) return true
  
  if (key === 'affiliation') return validateAffiliate(value)
  else if (key === 'call_sign') return validateCallSign(value)
  else if (key === 'dma_code') return validateDMACode(value)
  else if (key === 'time_zone') return validateTimeZone(value)

  else return true;
}

function validateAffiliate(value){
  let validAffiliates = ["", "abc", "catchycomedy", "cbs", "cw", "cw/mytv", "dabl", "fox", "independent", "ktxs rebroadcast", "metv",
                          "mynet", "mytv", "nbc", "pbs", "tbd", "telemundo", "unimas", "univision", "test"]
  value = value.toLowerCase()

  if (validAffiliates.includes(value)) return true
  return false
}

function validateCallSign(value){
  let specialCallSigns = ["", "fema", "sealab", "omlab", "test"]
  value = value.toLowerCase()
  if (specialCallSigns.includes(value)) return true


  let firstLetter = value.charAt(0)
  if (value.length === 4 && (firstLetter === 'k' || firstLetter === 'w')) return true
  
  let hyphen = value.charAt(4)
  if (value.length === 7 && hyphen === '-' && (firstLetter === 'k' || firstLetter === 'w')) return true

  return false
}

function validateDMACode(value){
  let regex = /^[5-8]\d\d$/
  if (value === "" || regex.test(value) || value === '-1') return true
  return false
}

function validateTimeZone(value){
  let validTimeZones = ["", 'akst', 'akdt', 'ast', 'adt', 'est', 'edt', 'cst', 'cdt', 'hst', 'hdt', 'mst', 'mdt', 'sst', 'sdt', 'pst', 'pdt', "test"]
  value = value.toLowerCase()
  if (validTimeZones.includes(value)) return true
  return false
}
